import { render, staticRenderFns } from "./lightHeader.vue?vue&type=template&id=9058e4e2&scoped=true"
import script from "./lightHeader.vue?vue&type=script&lang=js"
export * from "./lightHeader.vue?vue&type=script&lang=js"
import style0 from "./lightHeader.vue?vue&type=style&index=0&id=9058e4e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9058e4e2",
  null
  
)

export default component.exports